import { render, staticRenderFns } from "./ShippingDetails.vue?vue&type=template&id=50d9c73e&scoped=true"
import script from "./ShippingDetails.vue?vue&type=script&lang=js"
export * from "./ShippingDetails.vue?vue&type=script&lang=js"
import style0 from "./ShippingDetails.vue?vue&type=style&index=0&id=50d9c73e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d9c73e",
  null
  
)

export default component.exports